import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

const PUBLIC_GRAPHQL_OPERATIONS = [
  'PublicRatingQuestions',
  'PublicCreateManyGymRatings',
  'PublicContractDetails',
  'GenerateContract',
  'SubmitCommunityClubOnboarding',
  'CommunityClubOnboardingEmailExists',
];

@Injectable()
export class AuthInterceptor extends AuthHttpInterceptor {
  override intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url === environment.HTTP_GRAPHQL_ENDPOINT) {
      const operationName = extractGraphQlOperationName(req.body);
      if (operationName && PUBLIC_GRAPHQL_OPERATIONS.includes(operationName)) {
        return next.handle(req);
      }
      return super.intercept(req, next);
    }

    return super.intercept(req, next);
  }
}

/**
 * Reads the GraphQL `operationName` from a request body - either a plain JSON body, or a
 * multipart `FormData` body (file uploads, per the GraphQL multipart request spec: the query/
 * variables/operationName live as a JSON string in the `operations` field, not as top-level
 * FormData entries).
 */
function extractGraphQlOperationName(body: unknown): string | null {
  if (body instanceof FormData) {
    const operations = body.get('operations');
    if (typeof operations !== 'string') {
      return null;
    }
    try {
      const parsed = JSON.parse(operations) as { operationName?: string };
      return parsed.operationName ?? null;
    } catch {
      return null;
    }
  }

  if (body instanceof Object && 'operationName' in body) {
    return (body as { operationName?: string }).operationName ?? null;
  }

  return null;
}
